import { NgModule } from '@angular/core';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';

import { TmsAppSharedModule, TmsLibModule } from 'tms-lib';
import {
  CustomerCreditCheckComponent,
  CustomerCreditSalesOrdersComponent,
  DespatchShipperInterfaceComponent,
  LocationSelectRendererComponent,
  OrderPropertiesComponent,
  OrderPropertyModalComponent,
  ProductCustomersModalComponent,
  ProductLogoComponent,
  ProductQuantityRendererComponent,
  ProductRendererComponent,
  ProductSearchRendererComponent,
  ProductStockAllocationsComponent,
  ProductStockForecastingComponent,
  ProductSuppliersModalComponent,
  PurchaseOrderCommentComponent,
  PurchaseOrderLineDetailsComponent,
  PurchaseOrderLineModalComponent,
  PurchaseOrderLinePurchaseOrderAllocationComponent,
  PurchaseOrderLineReceiptsComponent,
  PurchaseOrderLineRequirementModalComponent,
  PurchaseOrderLineRequirementsComponent,
  PurchaseOrderLineSalesOrderAllocationComponent,
  PurchaseOrderLineSalesOrderAllocationsModalComponent,
  SalesOrderHeaderCommentsComponent,
  SalesOrderLineAllocationsComponent,
  StockEnquiryDashboardComponent,
  StockEnquiryPurchaseOrderHistoryComponent,
  StockEnquirySalesOrderHistoryComponent,
  StockEnquiryStockAllocationsModalComponent,
  StockEnquiryUsedInComponent,
  StockItemCommentsComponent,
  StockItemsByProductComponent,
  StoreDocumentsComponent,
} from './components';
import { ShipperInterfaceDetailsModalComponent } from './components/shipping/shipper-interface-details-modal/shipper-interface-details-modal.component';

const administrationComponents = [OrderPropertiesComponent, OrderPropertyModalComponent];

const generalComponents = [StoreDocumentsComponent];

const gridRenderers = [
  LocationSelectRendererComponent,
  ProductRendererComponent,
  ProductQuantityRendererComponent,
  ProductSearchRendererComponent,
];

const productionComponents = [
  ProductCustomersModalComponent,
  ProductLogoComponent,
  ProductStockForecastingComponent,
  ProductSuppliersModalComponent,
];

const purchasingComponents = [
  PurchaseOrderCommentComponent,
  PurchaseOrderLineDetailsComponent,
  PurchaseOrderLineModalComponent,
  PurchaseOrderLinePurchaseOrderAllocationComponent,
  PurchaseOrderLineReceiptsComponent,
  PurchaseOrderLineRequirementModalComponent,
  PurchaseOrderLineRequirementsComponent,
  PurchaseOrderLineSalesOrderAllocationComponent,
  PurchaseOrderLineSalesOrderAllocationsModalComponent,
];

const salesComponents = [
  CustomerCreditCheckComponent,
  CustomerCreditSalesOrdersComponent,
  SalesOrderHeaderCommentsComponent,
  SalesOrderLineAllocationsComponent,
];

const shippingComponents = [DespatchShipperInterfaceComponent, ShipperInterfaceDetailsModalComponent];

const stockComponents = [
  ProductStockAllocationsComponent,
  StockEnquiryStockAllocationsModalComponent,
  StockEnquirySalesOrderHistoryComponent,
  StockEnquiryPurchaseOrderHistoryComponent,
  StockEnquiryDashboardComponent,
  StockEnquiryUsedInComponent,
  StockItemsByProductComponent,
  StockItemCommentsComponent,
];

const components = [
  ...administrationComponents,
  ...generalComponents,
  ...gridRenderers,
  ...productionComponents,
  ...purchasingComponents,
  ...salesComponents,
  ...shippingComponents,
  ...stockComponents,
];

@NgModule({
  imports: [TmsAppSharedModule, AgGridModule, Ng2GoogleChartsModule, NgbDatepickerModule, NgSelectModule],
  declarations: [
    components,
    SalesOrderHeaderCommentsComponent,
    StockEnquirySalesOrderHistoryComponent,
    StockEnquiryPurchaseOrderHistoryComponent,
  ],
  exports: [TmsAppSharedModule, TmsLibModule, ...components],
})
export class TmsWebSharedModule {}
